__turbopack_context__.v({
  "HeadLine": "jZxgna_HeadLine",
  "Root": "jZxgna_Root",
  "Root--Medium": "jZxgna_Root--Medium",
  "Root--Small": "jZxgna_Root--Small",
  "skeleton-loading": "jZxgna_skeleton-loading",
});
